/* eslint-disable no-multi-assign, func-names */
import * as types from 'constants/action_types'
import { getShortAgentName } from '../util/agents'

const COLORS = [
  'hsl(45, 76%, 57%)',
  'hsl(187, 69%, 53%)',
  'rgba(220, 86, 56, 1)',
  'rgba(145, 30, 180, 0.7)',
  'rgba(245, 130, 48, 0.7)',
  'rgba(230, 25, 75, 0.7)',
  'rgba(52, 130, 234, 0.7)',
  'rgba(210, 245, 60, 0.9)',
  'rgba(240, 50, 230, 0.7)',
  'rgba(70, 240, 240, 0.7)',
  'rgba(250, 190, 190, 0.7)',
  'rgba(0, 128, 128, 0.7)',
  'rgba(230, 190, 255, 0.7)',
  'rgba(170, 110, 40, 0.7)',
  'rgba(255, 250, 200, 0.7)',
  'rgba(128, 0, 0, 0.7)',
  'rgba(170, 255, 195, 0.7)',
  'rgba(128, 128, 0, 0.7)',
  'rgba(255, 215, 180, 0.7)',
  'rgba(0, 0, 128, 0.7)',
  'rgba(128, 128, 128, 0.7)',
  'rgba(0, 0, 0, 0.7)',
  'rgba(60, 180, 75, 0.7)',
  'rgba(255, 225, 25, 0.7)',
]

function assignColorToMailbox(mailbox, index) {
  if (mailbox.color) return mailbox
  return {
    ...mailbox,
    color: COLORS[index % COLORS.length],
  }
}

const reducers = {}
const defaultState = {}

reducers[types.UPDATE_APP_DATA] = (state, action) => {
  const data = action.data

  const currentUser = data.currentUser

  const foldersById = {}
  const folders = (data.folders || []).filter(({ visible }) =>
    [undefined, true].includes(visible)
  )
  let wantsUnifiedInbox = false
  let wantsAllMailboxes = false

  try {
    wantsUnifiedInbox = currentUser.preferences.unified_inbox
    wantsAllMailboxes =
      currentUser.preferences.prefers_v2_show_all_mailboxes_section
  } catch (e) {
    // pass
  }

  folders.forEach(folder => (foldersById[folder.id] = folder))
  const mailboxes = (data.mailboxes || []).map(mailbox => {
    return {
      ...mailbox,
      folders: mailbox.folders.map(folder => foldersById[folder.id] || folder),
    }
  })

  let newMailboxes

  if (wantsUnifiedInbox) {
    newMailboxes = [
      {
        id: null,
        name: 'Conversations',
        folders,
      },
    ]
  } else {
    newMailboxes = mailboxes.map((mailbox, index) => {
      return assignColorToMailbox(mailbox, index)
    })

    if (wantsAllMailboxes && newMailboxes && newMailboxes.length > 1) {
      newMailboxes.unshift({
        id: null,
        name: 'All Inboxes',
        folders,
      })
    }
  }

  const agents = (data.agents || [])
    .filter(agent => !agent.archived)
    .map(agent => {
      const shortName = getShortAgentName(data.agents, agent)
      return {
        ...agent,
        shortName,
      }
    })

  return {
    mailboxes: newMailboxes,
    folders,
    agents,
  }
}

export default function reducer(state = defaultState, action) {
  // this is here because a long reducer with many ifs is unreadable
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
